import React, { Fragment } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Loader from "../components/Loader";
import PageHeader from "../components/PageHeader";
import PhoneInput from "react-phone-input-2";
import { Country, State, City } from "country-state-city";
import { SITENAMEALIAS } from "../utils/init";
import { Link, withRouter } from "react-router-dom";
import {
  showToast,
  showHttpError,
  _isValidPhoneNo,
  currentPageAccess,
} from "../utils/library";
import {
  FetchMerchantStatus,
  FetchBasicVerification,
  FetchAllIndustry,
  BasicVerificationSubmit,
  userPhoneNumberCheck,
} from "../utils/service";

// Helper function to trim and normalize spaces
const normalizeSpaces = (value) => {
  if (!value) return "";
  return value.trim().replace(/\s+/g, " ");
};

// Helper function to remove ALL spaces from email
const normalizeEmail = (value) => {
  if (!value) return "";
  return value.replace(/\s/g, "");
};

// Helper function to capitalize first letter of each word
const capitalizeWords = (value) => {
  if (!value) return "";
  return value
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

const vs = {
  pageWrapper: {
    padding: "36px 24px 60px",
  },
  headerSection: {
    marginBottom: "32px",
  },
  backLink: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "13px",
    color: "var(--btn-color)",
    textDecoration: "none",
    marginBottom: "20px",
    cursor: "pointer",
    transition: "opacity 0.2s",
  },
  pageTitle: {
    fontSize: "24px",
    fontWeight: "700",
    color: "var(--text-color)",
    margin: 0,
  },
  pageSubtitle: {
    fontSize: "13px",
    opacity: 0.5,
    margin: "4px 0 0",
  },
  card: {
    background: "var(--body-color-less)",
    borderRadius: "16px",
    border: "1px solid var(--body-color-less2)",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
    marginBottom: "24px",
    overflow: "hidden",
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "20px 28px",
    borderBottom: "1px solid var(--body-color-less2)",
  },
  cardHeaderIcon: {
    width: "36px",
    height: "36px",
    borderRadius: "10px",
    background:
      "linear-gradient(135deg, color-mix(in srgb, var(--btn-color), transparent 85%), color-mix(in srgb, var(--btn-color), transparent 92%))",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  cardHeaderIconText: {
    fontSize: "16px",
    color: "var(--btn-color)",
  },
  cardHeaderTitle: {
    fontSize: "15px",
    fontWeight: "700",
    margin: 0,
  },
  cardBody: {
    padding: "24px 28px",
  },
  formRow: {
    display: "flex",
    gap: "20px",
    marginBottom: "20px",
  },
  formGroup: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  label: {
    fontSize: "12px",
    fontWeight: "600",
    color: "var(--text-color)",
    opacity: 0.7,
    marginBottom: "6px",
    textTransform: "uppercase",
    letterSpacing: "0.3px",
  },
  input: {
    width: "100%",
    padding: "10px 14px",
    fontSize: "14px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    color: "var(--text-color)",
    outline: "none",
    transition: "border-color 0.2s, box-shadow 0.2s",
    boxSizing: "border-box",
  },
  select: {
    width: "100%",
    padding: "10px 14px",
    fontSize: "14px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    color: "var(--text-color)",
    outline: "none",
    transition: "border-color 0.2s, box-shadow 0.2s",
    boxSizing: "border-box",
    appearance: "auto",
  },
  checkboxGroup: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginTop: "24px",
  },
  checkbox: {
    width: "18px",
    height: "18px",
    cursor: "pointer",
  },
  checkboxLabel: {
    fontSize: "14px",
    fontWeight: "500",
    color: "var(--text-color)",
    cursor: "pointer",
  },
  errorText: {
    fontSize: "11px",
    color: "#ef4444",
    marginTop: "4px",
    fontWeight: "500",
  },
  infoNote: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
    padding: "14px 18px",
    background:
      "linear-gradient(135deg, color-mix(in srgb, var(--btn-color), transparent 92%), color-mix(in srgb, var(--btn-color), transparent 96%))",
    borderRadius: "10px",
    marginBottom: "24px",
    border: "1px solid color-mix(in srgb, var(--btn-color), transparent 80%)",
  },
  infoNoteIcon: {
    fontSize: "16px",
    color: "var(--btn-color)",
    marginTop: "1px",
    flexShrink: 0,
  },
  infoNoteText: {
    fontSize: "13px",
    lineHeight: "1.5",
    opacity: 0.8,
    margin: 0,
  },
  submitArea: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "20px 28px",
    borderTop: "1px solid var(--body-color-less2)",
    background: "var(--body-color-less)",
    borderRadius: "0 0 16px 16px",
  },
  submitWarning: {
    fontSize: "12px",
    opacity: 0.5,
    maxWidth: "400px",
    lineHeight: "1.5",
    margin: 0,
  },
  btnPrimary: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "11px 32px",
    background: "var(--btn-color)",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
    flexShrink: 0,
  },
  btnDisabled: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "11px 32px",
    background: "var(--body-color-less2)",
    color: "var(--text-color)",
    border: "none",
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "not-allowed",
    opacity: 0.5,
    flexShrink: 0,
  },
  viewModeBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "6px 16px",
    background: "#10b981",
    color: "#fff",
    fontSize: "12px",
    fontWeight: "600",
    borderRadius: "20px",
    marginLeft: "12px",
  },
  threeCol: {
    display: "flex",
    gap: "20px",
    marginBottom: "20px",
  },
  ownerRow: {
    display: "flex",
    gap: "20px",
    marginBottom: "20px",
    alignItems: "flex-start",
  },
  removeBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "36px",
    height: "36px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    color: "#ef4444",
    cursor: "pointer",
    flexShrink: 0,
    marginTop: "24px",
    transition: "all 0.2s ease",
  },
  addOwnerBtn: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "9px 20px",
    background: "transparent",
    color: "var(--btn-color)",
    border: "1px dashed var(--btn-color)",
    borderRadius: "10px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
};

class BasicVerification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      pageNo: 1,
      noOfItemsPerPage: 20,
      industries: [],
      verifyBtn: true,

      industrySearchTerm: "",
      showIndustryDropdown: false,
      selectedIndustryId: "",

      isOrgNameValid: false,
      isAddressValid: false,
      isAddressValid2: false,
      isValidCityName: false,
      isValidStateName: false,
      isValidZipcode: false,
      isValidBusinessName: false,
      isValidPhone: false,
      beneficialOwners: [
        {
          firstName: "",
          lastName: "",
          email: "",
          phoneNo: "",
          countryCode: "",
          countryIso: "",
          ownershipPercent: "",
          isPrimary: false,
          isValidFirstName: false,
          isValidLastName: false,
          isValidEmail: false,
          isValidPhone: false,
          isValidOwnership: false,
        },
      ],
      isValidFirstName: false,
      isValidLastName: false,
      isValidPhoneNumber: false,
      phoneVal: "",
      isPhoneReadOnly: false,
      isVerificationDone: localStorage.getItem(
        SITENAMEALIAS + "_basic_verification_submitted"
      ),
      permission: "",

      allCountries: Country.getAllCountries(),
      selectedCountryIso: "",
      selectedStateIso: "",
      selectedCity: "",
      states: [],
      cities: [],
      phoneCountryCode: "us",

      countrySearchTerm: "",
      stateSearchTerm: "",
      citySearchTerm: "",
      showCountryDropdown: false,
      showStateDropdown: false,
      showCityDropdown: false,
    };

    this.organizationRef = React.createRef();
    this.addressLine1Ref = React.createRef();
    this.addressLine2Ref = React.createRef();
    this.emailRef = React.createRef();
    this.zipRef = React.createRef();
    this.industryRef = React.createRef();
    this.websiteRef = React.createRef();
    this.phoneRef = React.createRef();
  }

  // Helper method to format text input with proper spacing and capitalization
  formatTextInput = (value, shouldCapitalize = true) => {
    let formatted = normalizeSpaces(value);
    if (shouldCapitalize) {
      formatted = capitalizeWords(formatted);
    }
    return formatted;
  };

  handleCountryChange = (countryIso, countryName) => {
    if (countryIso) {
      const states = State.getStatesOfCountry(countryIso);
      const countryData = this.state.allCountries.find(
        (c) => c.isoCode === countryIso
      );
      const dialCode = countryData
        ? countryData.phonecode.replace(/\D/g, "")
        : "";
      this.setState({
        selectedCountryIso: countryIso,
        selectedStateIso: "",
        selectedCity: "",
        states: states,
        cities: [],
        phoneCountryCode: countryIso.toLowerCase(),
        phoneVal: dialCode,
        phoneLocalNumber: "",
        countrySearchTerm: countryName || "",
        stateSearchTerm: "",
        citySearchTerm: "",
        showStateDropdown: false,
        showCityDropdown: false,
        isValidPhoneNumber: false,
        verifyBtn: false,
      });
    } else {
      this.setState({
        selectedCountryIso: "",
        selectedStateIso: "",
        selectedCity: "",
        states: [],
        cities: [],
        phoneCountryCode: "us",
        phoneVal: "",
        phoneLocalNumber: "",
        countrySearchTerm: "",
        stateSearchTerm: "",
        citySearchTerm: "",
        isValidPhoneNumber: false,
        verifyBtn: false,
      });
    }
  };

  handleStateChange = (stateIso, stateName) => {
    if (stateIso) {
      const cities = City.getCitiesOfState(
        this.state.selectedCountryIso,
        stateIso
      );
      this.setState({
        selectedStateIso: stateIso,
        selectedCity: "",
        cities: cities,
        stateSearchTerm: stateName || "",
        citySearchTerm: "",
        showCityDropdown: false,
      });
    } else {
      this.setState({
        selectedStateIso: "",
        selectedCity: "",
        cities: [],
        stateSearchTerm: "",
        citySearchTerm: "",
        showCityDropdown: false,
      });
    }
  };

  handleCityChange = (cityName) => {
    this.setState({
      selectedCity: cityName,
      citySearchTerm: cityName,
    });
  };

  handleMerchantInfo = () => {
    this.setState({ showLoader: true });
    const parentMerchantId = localStorage.getItem(
      SITENAMEALIAS + "_parent_merchant_id"
    );
    const isSubMerchant = parentMerchantId && parentMerchantId != "0";
    let payload = {
      merchant_id: isSubMerchant
        ? parentMerchantId
        : localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    FetchBasicVerification(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          var response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            this.organizationRef.current.value = response.organization_name;
            this.addressLine1Ref.current.value = response.address_line_1;
            this.addressLine2Ref.current.value = response.address_line_2;

            if (response.industry_id) {
              const industry = this.state.industries.find(
                (ind) => ind.industry_id === response.industry_id
              );
              if (industry) {
                this.setState({
                  industrySearchTerm: industry.industry_name,
                  selectedIndustryId: response.industry_id,
                });
              }
              if (this.industryRef.current) {
                this.industryRef.current.value = response.industry_id;
              }
            }

            const owners = [];
            if (response.owners && Array.isArray(response.owners)) {
              response.owners.forEach((o, idx) => {
                let ownerCountryIso = o.country_iso || "";
                if (!ownerCountryIso && o.country_code) {
                  const matchedCountry = Country.getAllCountries().find(
                    (c) => c.phonecode === o.country_code
                  );
                  if (matchedCountry)
                    ownerCountryIso = matchedCountry.isoCode.toLowerCase();
                }
                owners.push({
                  firstName: o.first_name || "",
                  lastName: o.last_name || "",
                  email: normalizeEmail(o.email || ""),
                  phoneNo: o.phone_no || "",
                  countryCode: o.country_code || "",
                  countryIso: ownerCountryIso,
                  ownershipPercent:
                    o.ownership_percent != null
                      ? String(o.ownership_percent)
                      : "",
                  isPrimary: o.is_primary == 1,
                  isValidFirstName: false,
                  isValidLastName: false,
                  isValidEmail: false,
                  isValidPhone: false,
                  isValidOwnership: false,
                });
              });
            }
            if (owners.length === 0) {
              owners.push({
                firstName: "",
                lastName: "",
                email: "",
                phoneNo: "",
                countryCode: "",
                countryIso: "",
                ownershipPercent: "",
                isPrimary: false,
                isValidFirstName: false,
                isValidLastName: false,
                isValidEmail: false,
                isValidPhone: false,
                isValidOwnership: false,
              });
            }
            this.setState({ beneficialOwners: owners });
            this.setState({ phoneVal: response.phone_no });
            this.websiteRef.current.value = response.website;
            this.zipRef.current.value = response.zip;

            const countryIso = response.country || "";
            if (countryIso) {
              const states = State.getStatesOfCountry(countryIso);
              const country = this.state.allCountries.find(
                (c) => c.isoCode === countryIso
              );

              const stateIso = response.state || "";
              let stateName = "";
              let cities = [];

              if (stateIso) {
                const state = states.find((s) => s.isoCode === stateIso);
                stateName = state ? state.name : "";
                cities = City.getCitiesOfState(countryIso, stateIso);
              }

              const cityName = response.city || "";

              this.setState({
                selectedCountryIso: countryIso,
                selectedStateIso: stateIso,
                selectedCity: cityName,
                states: states,
                cities: cities,
                phoneCountryCode: countryIso.toLowerCase(),
                countrySearchTerm: country ? country.name : "",
                stateSearchTerm: stateName,
                citySearchTerm: cityName,
              });
            }

            this.setState({
              isPhoneReadOnly: true,
            });
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  handleIndustries = () => {
    this.setState({ showLoader: true });
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    FetchAllIndustry(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          this.setState(
            {
              industries: res.data,
            },
            () => {
              if (this.state.isVerificationDone != "0") {
                this.handleMerchantInfo();
              }
            }
          );
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  handleVerify = () => {
    if (this.state.permission == "WRITE") {
      for (let i = 0; i < this.state.beneficialOwners.length; i++) {
        const o = this.state.beneficialOwners[i];
        const ownerLabel = "Owner " + (i + 1);
        if (!o.firstName.trim()) {
          showToast("error", ownerLabel + ": First name is required");
          return;
        }
        if (!o.lastName.trim()) {
          showToast("error", ownerLabel + ": Last name is required");
          return;
        }
        if (!o.email.trim()) {
          showToast("error", ownerLabel + ": Email is required");
          return;
        }
        if (!o.phoneNo.trim()) {
          showToast("error", ownerLabel + ": Phone number is required");
          return;
        }
        if (o.phoneNo.trim().length < 8 || o.phoneNo.trim().length > 15) {
          showToast(
            "error",
            ownerLabel + ": Phone number must be between 8 and 15 digits"
          );
          return;
        }
        if (o.ownershipPercent === "") {
          showToast("error", ownerLabel + ": Ownership percent is required");
          return;
        }
      }

      const emails = this.state.beneficialOwners.map((o) =>
        o.email.trim().toLowerCase()
      );
      if (new Set(emails).size !== emails.length) {
        showToast("error", "Each owner must have a unique email address");
        return;
      }

      const phones = this.state.beneficialOwners.map((o) => o.phoneNo.trim());
      if (new Set(phones).size !== phones.length) {
        showToast("error", "Each owner must have a unique phone number");
        return;
      }

      const ownershipValues = this.state.beneficialOwners.map((o) =>
        parseFloat(o.ownershipPercent)
      );
      if (ownershipValues.some((v) => isNaN(v) || v < 1 || v > 100)) {
        showToast(
          "error",
          "Ownership percent must be between 1 and 100 for each owner"
        );
        return;
      }
      const totalOwnership = ownershipValues.reduce((sum, v) => sum + v, 0);
      if (totalOwnership > 100) {
        showToast("error", "Total ownership percent cannot exceed 100%");
        return;
      }

      const primaryCount = this.state.beneficialOwners.filter(
        (o) => o.isPrimary === true
      ).length;
      if (primaryCount < 1) {
        showToast("error", "There must be at least one primary owner");
        return;
      }

      if (
        this.state.phoneLocalNumber &&
        (this.state.phoneLocalNumber.length < 8 ||
          this.state.phoneLocalNumber.length > 15)
      ) {
        showToast("error", "Phone number must be between 8 and 15 digits");
        return;
      }

      const hasStates = this.state.states.length > 0;
      const hasCities = this.state.cities.length > 0;
      const stateValue = hasStates
        ? this.state.selectedStateIso
        : this.state.selectedCountryIso;
      const cityValue = !hasStates
        ? this.state.selectedCountryIso
        : hasCities
        ? this.state.selectedCity
        : this.state.selectedCountryIso;

      if (
        this.organizationRef.current.value != "" &&
        this.websiteRef.current.value != "" &&
        this.addressLine1Ref.current.value != "" &&
        this.state.selectedCountryIso != "" &&
        (!hasStates || this.state.selectedStateIso != "") &&
        (!hasStates || !hasCities || this.state.selectedCity != "") &&
        this.state.phoneVal != "" &&
        this.zipRef.current.value != "" &&
        this.state.selectedIndustryId != ""
      ) {
        let payload = {
          merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
          address_line_1: this.addressLine1Ref.current.value,
          address_line_2: this.addressLine2Ref.current.value,
          city: cityValue,
          state: stateValue,
          country: this.state.selectedCountryIso,
          zip: this.zipRef.current.value,
          industry_id: this.state.selectedIndustryId,
          organization_name: this.organizationRef.current.value,
          website: this.websiteRef.current.value,
          phone_no: this.state.phoneVal,
          owners: this.state.beneficialOwners.map((o) => ({
            first_name: o.firstName,
            last_name: o.lastName,
            email: normalizeEmail(o.email),
            phone_no: o.phoneNo,
            country_code: o.countryCode,
            country_iso: o.countryIso,
            ownership_percent: parseFloat(o.ownershipPercent),
            is_primary: o.isPrimary ? 1 : 0,
          })),
        };

        this.setState({ showLoader: true });
        BasicVerificationSubmit(payload)
          .then(
            function (res) {
              this.setState({ showLoader: false });
              var response = res.data[0];
              if (response.error != "0") {
                showToast(
                  "error",
                  response.error_msg ||
                    "Your business verification could not be completed. Please review your info and resubmit."
                );
              } else {
                showToast(
                  "success",
                  "Your business verification was successful"
                );
                localStorage.setItem(
                  SITENAMEALIAS + "_basic_verification_submitted",
                  "1"
                );
                localStorage.setItem(SITENAMEALIAS + "_account_status_id", "6");
                setTimeout(
                  function () {
                    this.props.history.push("/get-started");
                  }.bind(this),
                  2000
                );
              }
            }.bind(this)
          )
          .catch(
            function (err) {
              this.setState({ showLoader: false });
              showToast(
                "error",
                "Your business verification could not be completed. Please review your info and resubmit."
              );
            }.bind(this)
          );
      } else {
        showToast("error", "Please provide all the fields");
      }
    } else {
      showToast("error", "You need write access to perform this operation");
    }
  };

  checkOrgName = (e) => {
    const rawValue = e.target.value;
    const formattedValue = this.formatTextInput(rawValue, true);
    if (formattedValue !== rawValue) {
      e.target.value = formattedValue;
    }
    const regex = /^[A-Za-z0-9\s\-.]+$/;
    if (regex.test(formattedValue)) {
      this.setState({ isOrgNameValid: false, verifyBtn: false });
    } else {
      this.setState({ isOrgNameValid: true, verifyBtn: true });
    }
  };

  checkAddress1 = (e) => {
    const rawValue = e.target.value;
    const formattedValue = normalizeSpaces(rawValue);
    if (formattedValue !== rawValue) {
      e.target.value = formattedValue;
    }
    let regex = /^[a-zA-Z0-9\s\/\.,-]+$/;
    if (regex.test(formattedValue)) {
      this.setState({ isAddressValid: false, verifyBtn: false });
    } else {
      this.setState({ isAddressValid: true, verifyBtn: true });
    }
  };

  checkAddress2 = (e) => {
    const rawValue = e.target.value;
    const formattedValue = normalizeSpaces(rawValue);
    if (formattedValue !== rawValue) {
      e.target.value = formattedValue;
    }
    let regex = /^[a-zA-Z0-9\s\/\.,-]+$/;
    if (regex.test(formattedValue) || formattedValue == "") {
      this.setState({ isAddressValid2: false, verifyBtn: false });
    } else {
      this.setState({ isAddressValid2: true, verifyBtn: true });
    }
  };

  checkZipCode = (e) => {
    const rawValue = e.target.value;
    const formattedValue = normalizeSpaces(rawValue);
    if (formattedValue !== rawValue) {
      e.target.value = formattedValue;
    }
    let regex = /^[a-zA-Z0-9- ]{1,15}$/;
    if (regex.test(formattedValue)) {
      this.setState({ isValidZipcode: false, verifyBtn: false });
    } else {
      this.setState({ isValidZipcode: true, verifyBtn: true });
    }
  };

  checkBusinessName = (e) => {
    const rawValue = e.target.value;
    const formattedValue = normalizeSpaces(rawValue);
    if (formattedValue !== rawValue) {
      e.target.value = formattedValue;
    }
    let regex =
      /^(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]+)*\.[a-zA-Z]{2,}(?:\/[a-zA-Z0-9#?=&\/_.-]*)*$/;
    if (regex.test(formattedValue)) {
      this.setState({ isValidBusinessName: false, verifyBtn: false });
    } else {
      this.setState({ isValidBusinessName: true, verifyBtn: true });
    }
  };

  addBeneficialOwner = () => {
    if (this.state.beneficialOwners.length >= 10) {
      showToast("error", "You can add a maximum of 10 beneficial owners");
      return;
    }
    this.setState((prev) => ({
      beneficialOwners: [
        ...prev.beneficialOwners,
        {
          firstName: "",
          lastName: "",
          email: "",
          phoneNo: "",
          countryCode: "",
          countryIso: "",
          ownershipPercent: "",
          isPrimary: false,
          isValidFirstName: false,
          isValidLastName: false,
          isValidEmail: false,
          isValidPhone: false,
          isValidOwnership: false,
        },
      ],
    }));
  };

  removeBeneficialOwner = (index) => {
    this.setState((prev) => ({
      beneficialOwners: prev.beneficialOwners.filter((_, i) => i !== index),
    }));
  };

  handleOwnerFirstName = (index, e) => {
    const rawValue = e.target.value;
    const formattedValue = this.formatTextInput(rawValue, true);
    const regex = /^[a-zA-Z\-]{2,20}$/;
    const isValid = formattedValue !== "" ? !regex.test(formattedValue) : false;

    this.setState((prev) => {
      const owners = [...prev.beneficialOwners];
      owners[index] = {
        ...owners[index],
        firstName: formattedValue,
        isValidFirstName: isValid,
      };
      return { beneficialOwners: owners };
    });
  };

  handleOwnerLastName = (index, e) => {
    const rawValue = e.target.value;
    const formattedValue = this.formatTextInput(rawValue, true);
    const regex = /^[a-zA-Z]+([ -]?[a-zA-Z]+){0,9}$/;
    const isValid = formattedValue !== "" ? !regex.test(formattedValue) : false;

    this.setState((prev) => {
      const owners = [...prev.beneficialOwners];
      owners[index] = {
        ...owners[index],
        lastName: formattedValue,
        isValidLastName: isValid,
      };
      return { beneficialOwners: owners };
    });
  };

  // FIXED: Block spaces from being entered and remove existing spaces
  handleOwnerEmailChange = (index, e) => {
    const rawValue = e.target.value;
    // Remove all spaces using regex
    const cleanedValue = rawValue.replace(/\s/g, "");

    // Update state with cleaned value
    this.setState((prev) => {
      const owners = [...prev.beneficialOwners];
      owners[index] = {
        ...owners[index],
        email: cleanedValue,
        isValidEmail: false,
        emailError: "",
      };
      return { beneficialOwners: owners };
    });
  };

  // Prevent space key from being entered
  handleEmailKeyDown = (e) => {
    if (e.key === " " || e.key === "Space") {
      e.preventDefault();
    }
  };

  // Handle paste event to remove spaces from pasted content
  handleEmailPaste = (index, e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData("text");
    const cleanedText = pastedText.replace(/\s/g, "");

    this.setState((prev) => {
      const owners = [...prev.beneficialOwners];
      owners[index] = {
        ...owners[index],
        email: cleanedText,
        isValidEmail: false,
        emailError: "",
      };
      return { beneficialOwners: owners };
    });
  };

  validateOwnerEmail = (index) => {
    const owner = this.state.beneficialOwners[index];
    const val = owner.email.trim();
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let errorMsg = "";
    if (val !== "" && !regex.test(val)) {
      errorMsg = "Please insert valid email";
    } else if (val !== "") {
      const duplicate = this.state.beneficialOwners.some(
        (o, i) =>
          i !== index && o.email.trim().toLowerCase() === val.toLowerCase()
      );
      if (duplicate) errorMsg = "Email must be unique across owners";
    }

    this.setState((prev) => {
      const owners = [...prev.beneficialOwners];
      owners[index] = {
        ...owners[index],
        isValidEmail: !!errorMsg,
        emailError: errorMsg,
      };
      return { beneficialOwners: owners };
    });
  };

  togglePrimaryOwner = (index) => {
    this.setState((prev) => {
      const owners = [...prev.beneficialOwners];
      owners[index] = {
        ...owners[index],
        isPrimary: !owners[index].isPrimary,
      };
      return { beneficialOwners: owners };
    });
  };

  componentDidMount() {
    this.handleIndustries();
    this.setState({
      permission: currentPageAccess(),
    });
  }

  render() {
    const isViewMode = this.state.isVerificationDone === "1";
    const isReadOnly = isViewMode;

    return (
      <Fragment>
        <style>{`
          @media (max-width: 576px) {
            .bv-form-row { flex-direction: column !important; }
            .bv-three-col { flex-direction: column !important; }
            .bv-submit-area {
              flex-direction: column !important;
              align-items: flex-start !important;
              gap: 16px !important;
            }
            .bv-submit-area .bv-submit-warning {
              max-width: 100% !important;
              font-size: 11px !important;
            }
            .bv-submit-area .bv-verify-btn {
              width: 100% !important;
              justify-content: center !important;
            }
            .bv-info-note-text {
              font-size: 12px !important;
            }
          }
        `}</style>
        <div className="container-scroller">
          <Sidebar />
          <Header />
          <div className="main-panel">
            <div style={vs.pageWrapper}>
              <div style={vs.headerSection}>
                <Link to="/get-started" style={vs.backLink}>
                  <i
                    className="fas fa-arrow-left"
                    style={{ fontSize: "12px" }}
                  ></i>
                  Back to Get Started
                </Link>
                <PageHeader
                  icon="mdi-briefcase-check"
                  title={
                    isViewMode ? "Verification Details" : "Business Activation"
                  }
                  subtitle={
                    !isViewMode
                      ? "Basic verification will allow you to process real payments up to $100 daily and 30 payments monthly. We will send you a confirmation email within a few minutes of submitting your verification."
                      : undefined
                  }
                >
                  {isViewMode && (
                    <span style={vs.viewModeBadge}>
                      <i
                        className="fas fa-check"
                        style={{ fontSize: "10px" }}
                      ></i>
                      Verified
                    </span>
                  )}
                </PageHeader>
              </div>

              <div style={vs.card}>
                <div style={vs.cardHeader}>
                  <div style={vs.cardHeaderIcon}>
                    <i
                      className="fas fa-building"
                      style={vs.cardHeaderIconText}
                    ></i>
                  </div>
                  <h3 style={vs.cardHeaderTitle}>Business Information</h3>
                </div>
                <form style={vs.cardBody} autoComplete="off">
                  <div className="bv-form-row" style={vs.formRow}>
                    <div style={vs.formGroup}>
                      <label style={vs.label}>
                        Legal Name of Business{" "}
                        <span style={{ color: "#ef4444" }}>*</span>
                      </label>
                      <input
                        type="text"
                        style={vs.input}
                        ref={this.organizationRef}
                        onBlur={this.checkOrgName}
                        placeholder="Enter legal name of business"
                        readOnly={isReadOnly}
                        maxLength={100}
                        autoComplete="one-time-code"
                      />
                      {this.state.isOrgNameValid && (
                        <span style={vs.errorText}>
                          Please insert valid Business Name
                        </span>
                      )}
                    </div>
                    <div style={vs.formGroup}>
                      <label style={vs.label}>
                        Industry <span style={{ color: "#ef4444" }}>*</span>
                      </label>
                      <div style={{ position: "relative" }}>
                        <input
                          type="text"
                          style={{
                            ...vs.select,
                            cursor: "pointer",
                            backgroundColor: isReadOnly ? "#f5f5f5" : "white",
                          }}
                          placeholder="Search or select Industry"
                          value={this.state.industrySearchTerm || ""}
                          onChange={(e) => {
                            this.setState({
                              industrySearchTerm: e.target.value,
                              showIndustryDropdown: true,
                            });
                          }}
                          onFocus={() =>
                            this.setState({ showIndustryDropdown: true })
                          }
                          onBlur={() =>
                            setTimeout(
                              () =>
                                this.setState({ showIndustryDropdown: false }),
                              200
                            )
                          }
                          disabled={isReadOnly}
                          ref={this.industryRef}
                          autoComplete="one-time-code"
                        />
                        {this.state.showIndustryDropdown && (
                          <div
                            style={{
                              position: "absolute",
                              top: "100%",
                              left: 0,
                              right: 0,
                              maxHeight: "200px",
                              overflowY: "auto",
                              backgroundColor: "var(--body-color-less3)",
                              borderRadius: "4px",
                              zIndex: 1000,
                              marginTop: "2px",
                              color: "var(--text-color)",
                            }}
                          >
                            {(this.state.industries || [])
                              .filter((iter) => {
                                if (!iter || !iter.industry_name) return false;
                                const searchTerm = (
                                  this.state.industrySearchTerm || ""
                                ).toLowerCase();
                                return iter.industry_name
                                  .toLowerCase()
                                  .includes(searchTerm);
                              })
                              .map((iter) => (
                                <div
                                  key={iter.industry_id}
                                  style={{
                                    padding: "8px 12px",
                                    cursor: "pointer",
                                    backgroundColor: "var(--body-color-less3)",
                                  }}
                                  onClick={() => {
                                    this.setState({
                                      industrySearchTerm: iter.industry_name,
                                      showIndustryDropdown: false,
                                      selectedIndustryId: iter.industry_id,
                                    });
                                  }}
                                >
                                  {iter.industry_name}
                                </div>
                              ))}
                            {(this.state.industries || []).filter((iter) => {
                              if (!iter || !iter.industry_name) return false;
                              const searchTerm = (
                                this.state.industrySearchTerm || ""
                              ).toLowerCase();
                              return iter.industry_name
                                .toLowerCase()
                                .includes(searchTerm);
                            }).length === 0 && (
                              <div
                                style={{
                                  padding: "8px 12px",
                                  color: "#999",
                                  textAlign: "center",
                                }}
                              >
                                No industries found
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="bv-three-col" style={vs.threeCol}>
                    <div style={vs.formGroup}>
                      <label style={vs.label}>
                        Country <span style={{ color: "#ef4444" }}>*</span>
                      </label>
                      <div style={{ position: "relative" }}>
                        <input
                          type="text"
                          style={{
                            ...vs.select,
                            cursor: "pointer",
                            backgroundColor: isReadOnly ? "#f5f5f5" : "white",
                          }}
                          placeholder="Search or select Country"
                          value={this.state.countrySearchTerm || ""}
                          onChange={(e) => {
                            this.setState({
                              countrySearchTerm: e.target.value,
                              showCountryDropdown: true,
                            });
                          }}
                          onFocus={() =>
                            this.setState({ showCountryDropdown: true })
                          }
                          onBlur={() =>
                            setTimeout(
                              () =>
                                this.setState({ showCountryDropdown: false }),
                              200
                            )
                          }
                          disabled={isReadOnly}
                          autoComplete="one-time-code"
                        />
                        {this.state.showCountryDropdown && (
                          <div
                            style={{
                              position: "absolute",
                              top: "100%",
                              left: 0,
                              right: 0,
                              maxHeight: "200px",
                              overflowY: "auto",
                              backgroundColor: "var(--body-color-less3)",
                              borderRadius: "4px",
                              zIndex: 1000,
                              marginTop: "2px",
                              color: "var(--text-color)",
                            }}
                          >
                            {(this.state.allCountries || [])
                              .filter((c) => {
                                if (!c || !c.name) return false;
                                const searchTerm = (
                                  this.state.countrySearchTerm || ""
                                ).toLowerCase();
                                return c.name
                                  .toLowerCase()
                                  .includes(searchTerm);
                              })
                              .map((c) => (
                                <div
                                  key={c.isoCode}
                                  style={{
                                    padding: "8px 12px",
                                    cursor: "pointer",
                                    backgroundColor: "var(--body-color-less3)",
                                  }}
                                  onClick={() => {
                                    this.handleCountryChange(c.isoCode, c.name);
                                    this.setState({
                                      showCountryDropdown: false,
                                    });
                                  }}
                                >
                                  {c.name}
                                </div>
                              ))}
                            {(this.state.allCountries || []).filter((c) => {
                              if (!c || !c.name) return false;
                              const searchTerm = (
                                this.state.countrySearchTerm || ""
                              ).toLowerCase();
                              return c.name.toLowerCase().includes(searchTerm);
                            }).length === 0 && (
                              <div
                                style={{
                                  padding: "8px 12px",
                                  color: "#999",
                                  textAlign: "center",
                                }}
                              >
                                No countries found
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>

                    {(!this.state.selectedCountryIso ||
                      (this.state.states || []).length > 0) && (
                      <div style={vs.formGroup}>
                        <label style={vs.label}>
                          State <span style={{ color: "#ef4444" }}>*</span>
                        </label>
                        <div style={{ position: "relative" }}>
                          <input
                            type="text"
                            style={{
                              ...vs.select,
                              cursor: "pointer",
                              backgroundColor:
                                !this.state.selectedCountryIso || isReadOnly
                                  ? "#f5f5f5"
                                  : "white",
                            }}
                            placeholder="Search or select State"
                            value={this.state.stateSearchTerm || ""}
                            onChange={(e) => {
                              this.setState({
                                stateSearchTerm: e.target.value,
                                showStateDropdown: true,
                              });
                            }}
                            onFocus={() =>
                              this.setState({ showStateDropdown: true })
                            }
                            onBlur={() =>
                              setTimeout(
                                () =>
                                  this.setState({ showStateDropdown: false }),
                                200
                              )
                            }
                            disabled={
                              isReadOnly || !this.state.selectedCountryIso
                            }
                            autoComplete="one-time-code"
                          />
                          {this.state.showStateDropdown &&
                            this.state.selectedCountryIso && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: "100%",
                                  left: 0,
                                  right: 0,
                                  maxHeight: "200px",
                                  overflowY: "auto",
                                  backgroundColor: "var(--body-color-less3)",
                                  borderRadius: "4px",
                                  zIndex: 1000,
                                  marginTop: "2px",
                                  color: "var(--text-color)",
                                }}
                              >
                                {(this.state.states || [])
                                  .filter((s) => {
                                    if (!s || !s.name) return false;
                                    const searchTerm = (
                                      this.state.stateSearchTerm || ""
                                    ).toLowerCase();
                                    return s.name
                                      .toLowerCase()
                                      .includes(searchTerm);
                                  })
                                  .map((s) => (
                                    <div
                                      key={s.isoCode}
                                      style={{
                                        padding: "8px 12px",
                                        cursor: "pointer",
                                        backgroundColor:
                                          "var(--body-color-less3)",
                                      }}
                                      onClick={() => {
                                        this.handleStateChange(
                                          s.isoCode,
                                          s.name
                                        );
                                        this.setState({
                                          showStateDropdown: false,
                                        });
                                      }}
                                    >
                                      {s.name}
                                    </div>
                                  ))}
                                {(this.state.states || []).filter((s) => {
                                  if (!s || !s.name) return false;
                                  const searchTerm = (
                                    this.state.stateSearchTerm || ""
                                  ).toLowerCase();
                                  return s.name
                                    .toLowerCase()
                                    .includes(searchTerm);
                                }).length === 0 && (
                                  <div
                                    style={{
                                      padding: "8px 12px",
                                      color: "#999",
                                      textAlign: "center",
                                    }}
                                  >
                                    No states found
                                  </div>
                                )}
                              </div>
                            )}
                        </div>
                      </div>
                    )}

                    {(!this.state.selectedCountryIso ||
                      ((this.state.states || []).length > 0 &&
                        (!this.state.selectedStateIso ||
                          (this.state.cities || []).length > 0))) && (
                      <div style={vs.formGroup}>
                        <label style={vs.label}>
                          City <span style={{ color: "#ef4444" }}>*</span>
                        </label>
                        <div style={{ position: "relative" }}>
                          <input
                            type="text"
                            style={{
                              ...vs.select,
                              cursor: "pointer",
                              backgroundColor:
                                !this.state.selectedStateIso || isReadOnly
                                  ? "#f5f5f5"
                                  : "white",
                            }}
                            placeholder="Search or select City"
                            value={this.state.citySearchTerm || ""}
                            onChange={(e) => {
                              this.setState({
                                citySearchTerm: e.target.value,
                                showCityDropdown: true,
                              });
                            }}
                            onFocus={() =>
                              this.setState({ showCityDropdown: true })
                            }
                            onBlur={() =>
                              setTimeout(
                                () =>
                                  this.setState({ showCityDropdown: false }),
                                200
                              )
                            }
                            disabled={
                              isReadOnly || !this.state.selectedStateIso
                            }
                            autoComplete="one-time-code"
                          />
                          {this.state.showCityDropdown &&
                            this.state.selectedStateIso && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: "100%",
                                  left: 0,
                                  right: 0,
                                  maxHeight: "200px",
                                  overflowY: "auto",
                                  backgroundColor: "var(--body-color-less3)",
                                  borderRadius: "4px",
                                  zIndex: 1000,
                                  marginTop: "2px",
                                  color: "var(--text-color)",
                                }}
                              >
                                {(this.state.cities || [])
                                  .filter((c) => {
                                    if (!c || !c.name) return false;
                                    const searchTerm = (
                                      this.state.citySearchTerm || ""
                                    ).toLowerCase();
                                    return c.name
                                      .toLowerCase()
                                      .includes(searchTerm);
                                  })
                                  .map((c, i) => (
                                    <div
                                      key={c.name + "_" + i}
                                      style={{
                                        padding: "8px 12px",
                                        cursor: "pointer",
                                        backgroundColor:
                                          "var(--body-color-less3)",
                                      }}
                                      onClick={() => {
                                        this.handleCityChange(c.name);
                                        this.setState({
                                          showCityDropdown: false,
                                        });
                                      }}
                                    >
                                      {c.name}
                                    </div>
                                  ))}
                                {(this.state.cities || []).filter((c) => {
                                  if (!c || !c.name) return false;
                                  const searchTerm = (
                                    this.state.citySearchTerm || ""
                                  ).toLowerCase();
                                  return c.name
                                    .toLowerCase()
                                    .includes(searchTerm);
                                }).length === 0 && (
                                  <div
                                    style={{
                                      padding: "8px 12px",
                                      color: "#999",
                                      textAlign: "center",
                                    }}
                                  >
                                    No cities found
                                  </div>
                                )}
                              </div>
                            )}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="bv-form-row" style={vs.formRow}>
                    <div style={vs.formGroup}>
                      <label style={vs.label}>
                        Zip Code <span style={{ color: "#ef4444" }}>*</span>
                      </label>
                      <input
                        type="text"
                        style={vs.input}
                        ref={this.zipRef}
                        onBlur={this.checkZipCode}
                        placeholder="Zip code"
                        readOnly={isReadOnly}
                        autoComplete="one-time-code"
                      />
                      {this.state.isValidZipcode && (
                        <span style={vs.errorText}>
                          Please insert valid zipcode
                        </span>
                      )}
                    </div>
                    <div style={vs.formGroup}></div>
                  </div>

                  <div className="bv-form-row" style={vs.formRow}>
                    <div style={vs.formGroup}>
                      <label style={vs.label}>
                        Address Line 1{" "}
                        <span style={{ color: "#ef4444" }}>*</span>
                      </label>
                      <input
                        type="text"
                        style={vs.input}
                        ref={this.addressLine1Ref}
                        onBlur={this.checkAddress1}
                        placeholder="Street address"
                        readOnly={isReadOnly}
                        autoComplete="one-time-code"
                      />
                      {this.state.isAddressValid && (
                        <span style={vs.errorText}>
                          Please insert valid Address
                        </span>
                      )}
                    </div>
                    <div style={vs.formGroup}>
                      <label style={vs.label}>Address Line 2</label>
                      <input
                        type="text"
                        style={vs.input}
                        ref={this.addressLine2Ref}
                        onBlur={this.checkAddress2}
                        placeholder="Apt, suite, etc. (optional)"
                        readOnly={isReadOnly}
                        autoComplete="one-time-code"
                      />
                      {this.state.isAddressValid2 && (
                        <span style={vs.errorText}>
                          Please insert valid Address
                        </span>
                      )}
                    </div>
                  </div>
                </form>
              </div>

              <div style={vs.card}>
                <div style={vs.cardHeader}>
                  <div style={vs.cardHeaderIcon}>
                    <i
                      className="fas fa-globe"
                      style={vs.cardHeaderIconText}
                    ></i>
                  </div>
                  <h3 style={vs.cardHeaderTitle}>Website & Contact</h3>
                </div>
                <form style={vs.cardBody} autoComplete="off">
                  {!isViewMode && (
                    <div style={vs.infoNote}>
                      <i
                        className="fas fa-circle-info"
                        style={vs.infoNoteIcon}
                      ></i>
                      <p className="bv-info-note-text" style={vs.infoNoteText}>
                        Please ensure that your website or business profile is
                        online and accessible for verification.
                      </p>
                    </div>
                  )}
                  <div className="bv-form-row" style={vs.formRow}>
                    <div style={vs.formGroup}>
                      <label style={vs.label}>
                        Website or Business Profile{" "}
                        <span style={{ color: "#ef4444" }}>*</span>
                      </label>
                      <input
                        type="text"
                        style={vs.input}
                        ref={this.websiteRef}
                        onBlur={this.checkBusinessName}
                        placeholder="https://example.com"
                        readOnly={isReadOnly}
                        autoComplete="one-time-code"
                      />
                      {this.state.isValidBusinessName && (
                        <span style={vs.errorText}>
                          Please insert valid Business Name
                        </span>
                      )}
                    </div>
                    <div style={vs.formGroup}>
                      <label style={vs.label}>
                        Phone <span style={{ color: "#ef4444" }}>*</span>
                      </label>
                      <PhoneInput
                        placeholder="Enter phone number"
                        country={this.state.phoneCountryCode}
                        key={this.state.phoneCountryCode}
                        value={this.state.phoneVal}
                        disabled={this.state.isPhoneReadOnly}
                        disableDropdown={!!this.state.selectedCountryIso}
                        countryCodeEditable={false}
                        enableLongNumbers={false}
                        onChange={function (phoneVal, country) {
                          var dialCode = country.dialCode || "";
                          var localNumber = phoneVal;
                          if (phoneVal.startsWith(dialCode)) {
                            localNumber = phoneVal.slice(dialCode.length);
                          }
                          if (localNumber.length > 15) {
                            return;
                          }
                          this.setState({
                            phoneVal,
                            phoneLocalNumber: localNumber,
                            verifyBtn: false,
                            isValidPhoneNumber: false,
                          });
                        }.bind(this)}
                        inputProps={{
                          autoComplete: "off",
                        }}
                        inputStyle={{
                          width: "100%",
                          padding: "10px 14px 10px 48px",
                          fontSize: "14px",
                          borderRadius: "10px",
                          border: "1px solid var(--body-color-less2)",
                          background: "var(--body-color-less3)",
                          color: "var(--text-color)",
                          height: "auto",
                        }}
                        containerStyle={{ width: "100%" }}
                        buttonStyle={{
                          borderRadius: "10px 0 0 10px",
                          border: "1px solid var(--body-color-less2)",
                          background: "var(--body-color-less3)",
                        }}
                        dropdownStyle={{
                          background: "var(--body-color-less3)",
                          color: "var(--text-color)",
                          border: "1px solid var(--body-color-less2)",
                        }}
                      />
                      {this.state.isValidPhoneNumber && (
                        <span style={vs.errorText}>
                          Please enter a valid phone number
                        </span>
                      )}
                    </div>
                  </div>
                </form>
              </div>

              <div style={vs.card}>
                <div style={vs.cardHeader}>
                  <div style={vs.cardHeaderIcon}>
                    <i
                      className="fas fa-user-tie"
                      style={vs.cardHeaderIconText}
                    ></i>
                  </div>
                  <h3 style={vs.cardHeaderTitle}>Beneficial Owner</h3>
                </div>
                <form style={vs.cardBody} autoComplete="off">
                  {!isViewMode && (
                    <div style={vs.infoNote}>
                      <i
                        className="fas fa-circle-info"
                        style={vs.infoNoteIcon}
                      ></i>
                      <p style={vs.infoNoteText}>
                        Who owns this business? Please provide the full, legal
                        name of the beneficial owner(s).
                      </p>
                    </div>
                  )}
                  {this.state.beneficialOwners.map((owner, index) => (
                    <div
                      key={index}
                      style={{
                        marginBottom: "20px",
                        padding: "16px",
                        border: "1px solid var(--body-color-less2)",
                        borderRadius: "12px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          marginBottom: "12px",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "var(--text-color)",
                          }}
                        >
                          Owner {index + 1}{" "}
                          {owner.isPrimary === true && (
                            <span
                              style={{
                                color: "var(--btn-color)",
                                fontSize: "11px",
                                marginLeft: "6px",
                              }}
                            >
                              (Primary)
                            </span>
                          )}
                        </span>
                        {!isReadOnly &&
                          this.state.beneficialOwners.length > 1 && (
                            <button
                              type="button"
                              style={vs.removeBtn}
                              onClick={() => this.removeBeneficialOwner(index)}
                              title="Remove owner"
                            >
                              <i
                                className="fas fa-trash-alt"
                                style={{ fontSize: "14px" }}
                              ></i>
                            </button>
                          )}
                      </div>
                      <div className="bv-form-row" style={vs.formRow}>
                        <div style={vs.formGroup}>
                          <label style={vs.label}>
                            First Name{" "}
                            <span style={{ color: "#ef4444" }}>*</span>
                          </label>
                          <input
                            type="text"
                            style={vs.input}
                            value={owner.firstName}
                            onChange={(e) => {
                              const owners = [...this.state.beneficialOwners];
                              owners[index] = {
                                ...owners[index],
                                firstName: e.target.value,
                              };
                              this.setState({ beneficialOwners: owners });
                            }}
                            onBlur={(e) => this.handleOwnerFirstName(index, e)}
                            placeholder="First name"
                            readOnly={isReadOnly}
                            autoComplete="one-time-code"
                          />
                          {owner.isValidFirstName && (
                            <span style={vs.errorText}>
                              Please insert valid first name
                            </span>
                          )}
                        </div>
                        <div style={vs.formGroup}>
                          <label style={vs.label}>
                            Last Name{" "}
                            <span style={{ color: "#ef4444" }}>*</span>
                          </label>
                          <input
                            type="text"
                            style={vs.input}
                            value={owner.lastName}
                            onChange={(e) => {
                              const owners = [...this.state.beneficialOwners];
                              owners[index] = {
                                ...owners[index],
                                lastName: e.target.value,
                              };
                              this.setState({ beneficialOwners: owners });
                            }}
                            onBlur={(e) => this.handleOwnerLastName(index, e)}
                            placeholder="Last name"
                            readOnly={isReadOnly}
                            autoComplete="one-time-code"
                          />
                          {owner.isValidLastName && (
                            <span style={vs.errorText}>
                              Please insert valid last name
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="bv-form-row" style={vs.formRow}>
                        <div style={vs.formGroup}>
                          <label style={vs.label}>
                            Email <span style={{ color: "#ef4444" }}>*</span>
                          </label>
                          <input
                            type="email"
                            style={vs.input}
                            value={owner.email}
                            onChange={(e) =>
                              this.handleOwnerEmailChange(index, e)
                            }
                            onKeyDown={this.handleEmailKeyDown}
                            onPaste={(e) => this.handleEmailPaste(index, e)}
                            onBlur={() => this.validateOwnerEmail(index)}
                            placeholder="Email address"
                            readOnly={isReadOnly}
                            autoComplete="one-time-code"
                          />
                          {owner.isValidEmail && (
                            <span style={vs.errorText}>
                              {owner.emailError || "Please insert valid email"}
                            </span>
                          )}
                        </div>
                        <div style={vs.formGroup}>
                          <label style={vs.label}>
                            Phone No <span style={{ color: "#ef4444" }}>*</span>
                          </label>
                          <PhoneInput
                            placeholder="Enter phone number"
                            country={
                              owner.countryIso || this.state.phoneCountryCode
                            }
                            key={
                              (owner.countryIso ||
                                this.state.phoneCountryCode) +
                              "-" +
                              index
                            }
                            value={
                              (owner.countryCode || "") + (owner.phoneNo || "")
                            }
                            disabled={isReadOnly}
                            countryCodeEditable={false}
                            enableLongNumbers={false}
                            onChange={(value, country) => {
                              const dialCode = country.dialCode;
                              let localNumber = value;
                              if (value.startsWith(dialCode)) {
                                localNumber = value.slice(dialCode.length);
                              }
                              if (localNumber.length > 15) {
                                return;
                              }
                              const owners = [...this.state.beneficialOwners];
                              owners[index] = {
                                ...owners[index],
                                phoneNo: localNumber,
                                countryCode: dialCode,
                                countryIso: country.countryCode,
                                isValidPhone: false,
                                phoneError: "",
                              };
                              this.setState({ beneficialOwners: owners });
                            }}
                            onBlur={() => {
                              const val = owner.phoneNo.trim();
                              let errorMsg = "";
                              if (val !== "") {
                                const duplicate =
                                  this.state.beneficialOwners.some(
                                    (o, i) =>
                                      i !== index &&
                                      o.phoneNo.trim() === val &&
                                      o.countryCode === owner.countryCode
                                  );
                                if (duplicate)
                                  errorMsg =
                                    "Phone number must be unique across owners";
                              }
                              const owners = [...this.state.beneficialOwners];
                              owners[index] = {
                                ...owners[index],
                                isValidPhone: !!errorMsg,
                                phoneError: errorMsg,
                              };
                              this.setState({ beneficialOwners: owners });
                            }}
                            inputProps={{
                              autoComplete: "off",
                            }}
                            inputStyle={{
                              width: "100%",
                              padding: "10px 14px 10px 48px",
                              fontSize: "14px",
                              borderRadius: "10px",
                              border: "1px solid var(--body-color-less2)",
                              background: "var(--body-color-less3)",
                              color: "var(--text-color)",
                              height: "auto",
                            }}
                            containerStyle={{ width: "100%" }}
                            buttonStyle={{
                              borderRadius: "10px 0 0 10px",
                              border: "1px solid var(--body-color-less2)",
                              background: "var(--body-color-less3)",
                            }}
                            dropdownStyle={{
                              background: "var(--body-color-less3)",
                              color: "var(--text-color)",
                              border: "1px solid var(--body-color-less2)",
                            }}
                          />
                          {owner.isValidPhone && (
                            <span style={vs.errorText}>
                              {owner.phoneError ||
                                "Please insert valid phone number"}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="bv-form-row" style={vs.formRow}>
                        <div style={vs.formGroup}>
                          <label style={vs.label}>
                            Ownership Percent{" "}
                            <span style={{ color: "#ef4444" }}>*</span>
                          </label>
                          <input
                            type="number"
                            style={vs.input}
                            value={owner.ownershipPercent}
                            onChange={(e) => {
                              const owners = [...this.state.beneficialOwners];
                              owners[index] = {
                                ...owners[index],
                                ownershipPercent: e.target.value,
                                isValidOwnership: false,
                                ownershipError: "",
                              };
                              this.setState({ beneficialOwners: owners });
                            }}
                            onBlur={(e) => {
                              const val = parseFloat(e.target.value);
                              let errorMsg = "";
                              if (e.target.value !== "") {
                                if (isNaN(val) || val < 1 || val > 100) {
                                  errorMsg =
                                    "Ownership percent must be between 1 and 100";
                                } else {
                                  const total =
                                    this.state.beneficialOwners.reduce(
                                      (sum, o, i) => {
                                        const v =
                                          i === index
                                            ? val
                                            : parseFloat(o.ownershipPercent) ||
                                              0;
                                        return sum + v;
                                      },
                                      0
                                    );
                                  if (total > 100) {
                                    errorMsg =
                                      "Total ownership across all owners cannot exceed 100%";
                                  }
                                }
                              }
                              const owners = [...this.state.beneficialOwners];
                              owners[index] = {
                                ...owners[index],
                                isValidOwnership: !!errorMsg,
                                ownershipError: errorMsg,
                              };
                              if (
                                errorMsg &&
                                errorMsg !==
                                  "Total ownership across all owners cannot exceed 100%"
                              )
                                owners[index].ownershipPercent = "";
                              this.setState({ beneficialOwners: owners });
                            }}
                            placeholder="e.g. 60.00"
                            readOnly={isReadOnly}
                            min="1"
                            max="100"
                            step="0.01"
                            autoComplete="one-time-code"
                          />
                          {owner.isValidOwnership && (
                            <span style={vs.errorText}>
                              {owner.ownershipError ||
                                "Ownership percent must be between 1 and 100"}
                            </span>
                          )}
                        </div>
                        <div style={vs.formGroup}>
                          <div style={vs.checkboxGroup}>
                            <input
                              type="checkbox"
                              id={`primary_owner_${index}`}
                              style={vs.checkbox}
                              checked={owner.isPrimary === true}
                              onChange={() => this.togglePrimaryOwner(index)}
                              disabled={isReadOnly}
                              autoComplete="one-time-code"
                            />
                            <label
                              htmlFor={`primary_owner_${index}`}
                              style={vs.checkboxLabel}
                            >
                              Primary Owner
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                  {!isReadOnly && this.state.beneficialOwners.length < 10 && (
                    <button
                      type="button"
                      style={vs.addOwnerBtn}
                      onClick={this.addBeneficialOwner}
                    >
                      <i
                        className="fas fa-plus"
                        style={{ fontSize: "12px" }}
                      ></i>
                      Add Beneficial Owner
                    </button>
                  )}
                </form>

                {!isViewMode && (
                  <div className="bv-submit-area" style={vs.submitArea}>
                    <p className="bv-submit-warning" style={vs.submitWarning}>
                      <i
                        className="fas fa-triangle-exclamation"
                        style={{ marginRight: "6px", color: "#f59e0b" }}
                      ></i>
                      Please ensure the above information is correct as you will
                      not be able to make changes later.
                    </p>
                    <button
                      className="bv-verify-btn"
                      style={
                        this.state.verifyBtn && this.state.permission == "READ"
                          ? vs.btnDisabled
                          : vs.btnPrimary
                      }
                      type="button"
                      onClick={this.handleVerify}
                      disabled={
                        this.state.verifyBtn && this.state.permission == "READ"
                      }
                    >
                      <i
                        className="fas fa-shield-check"
                        style={{ fontSize: "14px" }}
                      ></i>
                      Verify Now
                    </button>
                  </div>
                )}
              </div>
            </div>

            <Footer />
          </div>
          <Loader show={this.state.showLoader} />
        </div>
      </Fragment>
    );
  }
}

export default withRouter(BasicVerification);
